import Vue from 'vue'

Vue.filter('log', console.log)
Vue.filter('json', (s: string) => JSON.stringify(s, undefined, 2))